<script setup>
const { injectSkinClasses } = useSkins()

// ℹ️ This will inject classes in body tag for accurate styling
injectSkinClasses()

useHead({
  link: [
    { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
    { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
    {
      rel: 'stylesheet',
      href: 'https://fonts.googleapis.com/css2?family=Geist:wght@300;400;500;600;700;800&family=Inter+Tight:wght@300;400;500;600;700;800&family=JetBrains+Mono:wght@400;500&display=swap',
    },
  ],
})
</script>

<template>
  <div
    class="layout-wrapper layout-blank kinetic-theme"
    data-theme="kinetic"
    data-allow-mismatch
  >
    <slot />
  </div>
</template>

<style>
.layout-wrapper.layout-blank {
  flex-direction: column;
}

/* Kinetic theme tokens — scoped to pages using the blank layout */
.layout-wrapper.layout-blank.kinetic-theme {
  --bg: #ffffff;
  --fg: #0a0a0b;
  --dim: #626266;
  --line: #ececee;
  --card: #f7f7f8;
  --accent: #0a66ff;
  --accent-ink: #ffffff;
  --font-display: 'Geist', 'Inter Tight', system-ui, sans-serif;
  --font-body: 'Geist', 'Inter Tight', system-ui, sans-serif;
  --font-mono: 'JetBrains Mono', ui-monospace, monospace;
  --radius: 16px;
  --maxw: 1280px;

  background: var(--bg);
  color: var(--fg);
  font-family: var(--font-body);
}

.layout-wrapper.layout-blank.kinetic-theme ::selection {
  background: var(--accent);
  color: var(--accent-ink);
}

/* Shared motion primitives */
.layout-wrapper.layout-blank.kinetic-theme .reveal {
  opacity: 0;
  transform: translateY(24px);
  transition: opacity .9s cubic-bezier(.2,.7,.2,1), transform .9s cubic-bezier(.2,.7,.2,1);
}
.layout-wrapper.layout-blank.kinetic-theme .reveal.in {
  opacity: 1;
  transform: none;
}

/* Shared animation library — available to every public page */
@keyframes kinetic-pulse-dot { 0%,100% { opacity: .35; } 50% { opacity: 1; } }
@keyframes kinetic-float-y { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-6px); } }
@keyframes kinetic-blink { 0%, 100% { opacity: 1; } 50% { opacity: .3; } }
@keyframes kinetic-pulse { 0%, 100% { opacity: .45; } 50% { opacity: 1; } }
@keyframes kinetic-ring { 0% { transform: scale(.4); opacity: .9; } 100% { transform: scale(2.6); opacity: 0; } }
@keyframes kinetic-sweep { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
@keyframes kinetic-feedin { from { opacity: 0; transform: translateY(-6px); } to { opacity: 1; transform: none; } }
@keyframes kinetic-bar-rise { from { height: 0; } }
@keyframes kinetic-marquee { from { transform: translateX(0); } to { transform: translateX(-50%); } }
@keyframes kinetic-slide-reverse { from { transform: translateX(-50%); } to { transform: translateX(0); } }
@keyframes kinetic-dash { to { stroke-dashoffset: -20; } }
@keyframes kinetic-tap { 0% { transform: translate(-50%,-50%) scale(.6); opacity: 1; } 100% { transform: translate(-50%,-50%) scale(2.6); opacity: 0; } }
@keyframes kinetic-flash { 0% { opacity: 0; } 30% { opacity: .07; } 100% { opacity: 0; } }
</style>
